/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx, Global } from "@emotion/react";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

const scrollLockStyles = css`
  body {
    overflow: hidden;
    padding-right: calc(100vw - 100%);
  }
`;

/**
 * モーダル等を開き、地画面をスクロールさせたくない場合に利用する
 * @constructor
 */
export const ScrollLock: FcWithoutChildren = () => (
  <Global styles={scrollLockStyles} />
);
